import { render, staticRenderFns } from "./main_box.vue?vue&type=template&id=0acc4218&scoped=true"
import script from "./main_box.vue?vue&type=script&lang=js"
export * from "./main_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acc4218",
  null
  
)

export default component.exports